import { TweenMax } from 'gsap';

type ReactRef = React.MutableRefObject<HTMLDivElement>;

interface AnimateHeroMap {
  [key: string]: ReactRef;
}

const animateHero = (elements: AnimateHeroMap) => {
  const {
    walletIcon,
    heroTopTitle,
    heroDescriptionRef,
    backgroundRef,
    heroBottomRef
  } = elements;

  TweenMax.fromTo(
    backgroundRef.current,
    2,
    {
      opacity: 0,
      rotate: 325,
      transformOrigin: 'center',
      ease: 'ease.in'
    },
    {
      opacity: 0.6,
      rotate: 360
    }
  );

  TweenMax.fromTo(
    walletIcon.current,
    1,
    {
      opacity: 0,
      y: -100
    },
    {
      opacity: 1,
      y: 0,
      ease: 'back.out(3)'
    }
  );

  const heroTopTitleSpan = heroTopTitle.current.getElementsByTagName('span');

  TweenMax.fromTo(
    heroTopTitle.current,
    1,
    {
      x: 100,
      opacity: 0
    },
    {
      x: 0,
      opacity: 1,
      ease: 'back.out(1.5)'
    }
  ).delay(0.4);

  TweenMax.fromTo(
    heroTopTitleSpan,
    1,
    {
      x: 100,
      opacity: 0
    },
    {
      x: 0,
      opacity: 1,
      ease: 'back.out(1.5)'
    }
  ).delay(0.6);

  TweenMax.fromTo(
    heroDescriptionRef.current,
    1,
    {
      y: 100,
      opacity: 0
    },
    {
      y: 0,
      opacity: 1,
      ease: 'back.out(1.7)'
    }
  ).delay(0.8);

  TweenMax.fromTo(
    heroBottomRef.current,
    0.4,
    { opacity: 0 },
    { opacity: 1 }
  ).delay(1.2);
};

export default animateHero;
